import { CSInterface } from "csinterface-ts";
import { rootStore } from "../../store/root";
import { jsxConstsEvents } from "../jsxConsts";
import { runAfterRender } from "../scripts/runAfterRender";
const { csInterface }: { csInterface: CSInterface } = window as any;

export function cancelRenderListener() {
  const {
    renderStore: { cancelProcess },
  } = rootStore;
  csInterface.addEventListener(jsxConstsEvents.cancelRender, async () => {
    cancelProcess();
    const compositions = rootStore.compositionStore.queuedCompositions || 0;
    const { beforeRenderState } = rootStore.renderStore;
    for (const composition of compositions) {
      await runAfterRender(composition, beforeRenderState);
    }
    rootStore.renderStore.setBeforeRenderState({});
  });
}
